import { render, staticRenderFns } from "./section-table.vue?vue&type=template&id=fb6170d8&scoped=true"
import script from "./section-table.vue?vue&type=script&lang=ts"
export * from "./section-table.vue?vue&type=script&lang=ts"
import style0 from "./section-table.vue?vue&type=style&index=0&id=fb6170d8&prod&lang=css"
import style1 from "./section-table.vue?vue&type=style&index=1&id=fb6170d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6170d8",
  null
  
)

export default component.exports